// src/mocks/models.ts
// Фейковые метрики подключённых моделей (FR-3).

export interface ModelMetrics {
  latencyMs: number;
  tokens30d: number;
}

/** Метрики для известных моделей; для добавленных вручную генерим в modelsAdminApi */
export const MODEL_METRICS: Record<string, ModelMetrics> = {
  'GPT-OSS-120B': { latencyMs: 420, tokens30d: 2830000 },
  'Gemma4-26B-MoE': { latencyMs: 180, tokens30d: 310000 },
  'Gemma4-E4B': { latencyMs: 95, tokens30d: 110000 },
};

export const DEFAULT_MODEL_HOSTS: Record<string, { host: string; port: number }> = {
  'GPT-OSS-120B': { host: '10.12.4.21', port: 8000 },
  'Gemma4-26B-MoE': { host: '10.12.4.22', port: 8000 },
  'Gemma4-E4B': { host: '10.12.4.23', port: 8001 },
};
